import EventCampaign from './EventCampaign';

export default EventCampaign;



// WEBPACK FOOTER //
// ./src/views/EventCampaign/index.js